import React, { createContext, useCallback, useMemo, useState } from 'react';

export const AUTH_STORAGE_KEY = 'exanta_auth';

const readStoredAuth = () => {
  try {
    const stored = window.localStorage.getItem(AUTH_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Failed to read stored auth', error);
    return null;
  }
};

export const AuthContext = createContext({
  auth: null,
  token: null,
  user: null,
  setAuth: () => {},
  logout: () => {}
});

export const AuthProvider = ({ children }) => {
  const [auth, setAuthState] = useState(readStoredAuth);

  const setAuth = useCallback((nextAuth) => {
    setAuthState(nextAuth);

    try {
      if (nextAuth) {
        window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(nextAuth));
      } else {
        window.localStorage.removeItem(AUTH_STORAGE_KEY);
      }
    } catch (error) {
      console.error('Failed to persist auth', error);
    }
  }, []);

  const logout = useCallback(() => {
    setAuth(null);
  }, [setAuth]);

  const value = useMemo(() => ({
    auth,
    token: auth && auth.access_token ? auth.access_token : null,
    user: auth && auth.user ? auth.user : null,
    setAuth,
    logout
  }), [auth, logout, setAuth]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
